export const STATIONS = [
    {
        chargeBoxId: "Test123",
        description: "TEste estacao",
    },
    {
        chargeBoxId: "Test2222",
        description: "TEste estacao 2",
    },
]